//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const BankRecDashboardConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/dashboard",
      component: FuseLoadable({
        loader: () => import("./BankRecDashboard.js")
      })
    }
  ]
  //end routes
};
